import {capitalize, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHasUsersWithoutEntry } from "../../client/queries";

export default function FreeDayMessage({ id }: { id: string }) {
  const hasActive = useHasUsersWithoutEntry(id);
  const { t: translation } = useTranslation("freedays");
  return (
    hasActive.hasUsersWithoutEntry && (
      <Typography color={"warning"} sx={{ paddingLeft: 3 }}>
        {capitalize(translation("message.notAllEmployeesHaveEntry"))}
      </Typography>
    )
  );
}
